import { Navigate } from "react-router-dom";

import {
  EmployeeBreadcrum,
  ProtectedRoute,
  TranslationBreadcrumb,
} from "components/UI";
import {
  Employee,
  DetailEmployee,
  AddEmployee,
  AddEmployeePersonal,
  AddEmployeeCareer,
  AddEmployeePayroll,
  ImportAddEmployee,
  ImportUpdateEmployee,
  ImportBankAccountEmployee,
  MainDetailLeaveAndPermission,
  MainDetailPersonal,
  DetailPersonal,
  DetailPersonalCareer,
  EmployeeAttendanceDaily,
  EmployeeAttendanceHistory,
  MainEmployeePayroll,
  DetailEmployeePayroll,
  EmployeeAddPayroll,
  EmployeeEditPayroll,
  EmployeeCareer,
  TerminateCareer,
  EmployeeCashReceipt,
  AddEmployeeCashReceipt,
  DetailEmployeeCashReceipt,
  EmployeeReimburse,
  AddReimburseEmployee,
  DetailReimburse,
  EditReimburse,
  PettyCashEmployee,
  MainNavigateEmployeeLeave,
  EmployeeTracking,
  EmployeeTask,
  EmployeeDetailTask,
  AddTask,
  DuplicateTask,
  EditTask,
  DetailContentLeave,
  DetailEmployeeLeave,
  AddEmployeeLeave,
  MainEmployeeSalaryHistory,
  AddCareer,
  DetailEmployeeCareer,
} from "./pages";

const employeeRoutes = [
  {
    path: "/employee",
    element: (
      <ProtectedRoute name="employee">
        <Employee />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="employee" defaultTitle="employee.title" />
    ),
  },
  {
    path: "/employee/add",
    element: (
      <ProtectedRoute name="employee_add">
        <AddEmployee />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name={"employee.add_employee"} />,
    children: [
      {
        path: "/employee/add/personal",
        element: <AddEmployeePersonal />,
        breadcrumb: () => <TranslationBreadcrumb name={"employee.personal"} />,
      },
      {
        path: "/employee/add/personal/:id",
        element: <AddEmployeePersonal />,
        breadcrumb: () => <TranslationBreadcrumb name={"employee.personal"} />,
      },
      {
        path: "/employee/add/career",
        element: <AddEmployeeCareer />,
        breadcrumb: () => <TranslationBreadcrumb name={"employee.staffing"} />,
      },
      {
        path: "/employee/add/career/:id",
        element: <AddEmployeeCareer />,
        breadcrumb: null,
      },
      {
        path: "/employee/add/payroll",
        element: <AddEmployeePayroll />,
        breadcrumb: () => <TranslationBreadcrumb name={"employee.payroll"} />,
      },
      {
        path: "/employee/add/payroll/:id",
        element: <AddEmployeePayroll />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/employee/import-add-employee",
    element: (
      <ProtectedRoute name="employee_add">
        <ImportAddEmployee />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"employee.import_add_employee"} />
    ),
  },
  {
    path: "/employee/import-update-employee",
    element: (
      <ProtectedRoute name="employee_edit">
        <ImportUpdateEmployee />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"employee.import_update_employee"} />
    ),
  },
  {
    path: "/employee/import-bank-account-employee",
    element: (
      <ProtectedRoute name="employee_edit">
        <ImportBankAccountEmployee />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"employee.import_employee_bank_account"} />
    ),
  },
  {
    path: "/employee/detail/:id",
    element: (
      <ProtectedRoute name="employee">
        <DetailEmployee />
      </ProtectedRoute>
    ),
    breadcrumb: EmployeeBreadcrum,
    children: [
      {
        path: "/employee/detail/:id/personal",
        element: <MainDetailPersonal />,
        breadcrumb: null,
        children: [
          {
            index: true,
            element: <DetailPersonal />,
            breadcrumb: null,
          },
          {
            path: "/employee/detail/:id/personal/career",
            element: <DetailPersonalCareer />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/employee/detail/:id/leaves",
        element: (
          <ProtectedRoute name="leaves">
            <MainDetailLeaveAndPermission />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb
            name="leaves"
            defaultTitle="breadcrumb.leave_and_permission"
          />
        ),
        children: [
          { index: true, element: <MainNavigateEmployeeLeave /> },
          {
            path: "/employee/detail/:id/leaves/annual-leave",
            element: (
              <DetailContentLeave key="annual-leave" type="annual-leave" />
            ),
            breadcrumb: null,
            children: [
              {
                path: "/employee/detail/:id/leaves/annual-leave/add",
                element: <AddEmployeeLeave />,
                breadcrumb: null,
              },
              {
                path: "/employee/detail/:id/leaves/annual-leave/detail/:leaveId",
                element: <DetailEmployeeLeave />,
                breadcrumb: null,
              },
            ],
          },
          {
            path: "/employee/detail/:id/leaves/special-leave",
            element: (
              <DetailContentLeave key="special-leave" type="special-leave" />
            ),
            breadcrumb: null,
            children: [
              {
                path: "/employee/detail/:id/leaves/special-leave/add",
                element: <AddEmployeeLeave />,
                breadcrumb: null,
              },
              {
                path: "/employee/detail/:id/leaves/special-leave/detail/:leaveId",
                element: <DetailEmployeeLeave />,
                breadcrumb: null,
              },
            ],
          },
          {
            path: "/employee/detail/:id/leaves/sick-leave",
            element: <DetailContentLeave key="sick-leave" type="sick-leave" />,
            breadcrumb: null,
            children: [
              {
                path: "/employee/detail/:id/leaves/sick-leave/add",
                element: <AddEmployeeLeave />,
                breadcrumb: null,
              },
              {
                path: "/employee/detail/:id/leaves/sick-leave/detail/:leaveId",
                element: <DetailEmployeeLeave />,
                breadcrumb: null,
              },
            ],
          },
          {
            path: "/employee/detail/:id/leaves/permission-leave",
            element: (
              <DetailContentLeave
                key="permission-leave"
                type="permission-leave"
              />
            ),
            breadcrumb: null,
            children: [
              {
                path: "/employee/detail/:id/leaves/permission-leave/add",
                element: <AddEmployeeLeave />,
                breadcrumb: null,
              },
              {
                path: "/employee/detail/:id/leaves/permission-leave/detail/:leaveId",
                element: <DetailEmployeeLeave />,
                breadcrumb: null,
              },
            ],
          },
          {
            path: "/employee/detail/:id/leaves/unpaid-leave",
            element: (
              <DetailContentLeave key="unpaid-leave" type="unpaid-leave" />
            ),
            breadcrumb: null,
            children: [
              {
                path: "/employee/detail/:id/leaves/unpaid-leave/add",
                element: <AddEmployeeLeave />,
                breadcrumb: null,
              },
              {
                path: "/employee/detail/:id/leaves/unpaid-leave/detail/:leaveId",
                element: <DetailEmployeeLeave />,
                breadcrumb: null,
              },
            ],
          },
          {
            path: "/employee/detail/:id/leaves/annual-leave/leave-history",
            element: (
              <DetailContentLeave key="leave-history" type="leave-history" />
            ),
            breadcrumb: null,
            children: [
              {
                path: "/employee/detail/:id/leaves/annual-leave/leave-history/detail/:leaveId",
                element: <DetailEmployeeLeave />,
                breadcrumb: null,
              },
            ],
          },
        ],
      },
      {
        path: "/employee/detail/:id/attendance-daily",
        element: (
          <ProtectedRoute name="presence">
            <EmployeeAttendanceDaily />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"employee.title_attendance_daily"} />
        ),
      },
      {
        path: "/employee/detail/:id/attendance-history",
        element: (
          <ProtectedRoute name="presence">
            <EmployeeAttendanceHistory />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"employee.attendance_history"} />
        ),
      },
      {
        path: "/employee/detail/:id/payroll",
        element: (
          <ProtectedRoute name="payroll_payment">
            <MainEmployeePayroll />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb
            name="payroll"
            defaultTitle="payroll.payroll"
          />
        ),
      },
      {
        path: "/employee/detail/:id/payroll/detail-payroll/:idPayroll",
        element: (
          <ProtectedRoute name="payroll_payment">
            <DetailEmployeePayroll />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"payroll.payroll_history"} />
        ),
      },
      {
        path: "/employee/detail/:id/payroll/add",
        element: (
          <ProtectedRoute name="payroll_payment_add">
            <EmployeeAddPayroll />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"payroll.add_payroll"} />
        ),
      },
      {
        path: "/employee/detail/:id/payroll/add/:idPayroll",
        element: (
          <ProtectedRoute name="payroll_payment_add">
            <EmployeeAddPayroll />
          </ProtectedRoute>
        ),
        breadcrumb: null,
      },
      {
        path: "/employee/detail/:id/payroll/edit/:idPayroll",
        element: (
          <ProtectedRoute name="payroll_payment_edit">
            <EmployeeEditPayroll />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"payroll.edit_payroll"} />
        ),
      },
      {
        path: "/employee/detail/:id/salary-history",
        element: (
          <ProtectedRoute name="payroll_payment">
            <MainEmployeeSalaryHistory />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"payroll.salary_history"} />
        ),
      },
      {
        path: "/employee/detail/:id/career",
        element: <EmployeeCareer />,
        breadcrumb: () => <TranslationBreadcrumb name={"employee.career"} />,
        children: [
          {
            path: "/employee/detail/:id/career/add",
            element: <AddCareer />,
            breadcrumb: null,
          },
          {
            path: "/employee/detail/:id/career/detail/:idCareer",
            element: <DetailEmployeeCareer />,
            breadcrumb: null,
          },
          {
            path: "/employee/detail/:id/career/terminate/:idCareer",
            element: <TerminateCareer />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/employee/detail/:id/finance",
        element: (
          <ProtectedRoute name="cash_receipt">
            <Navigate to="cash-receipt" replace />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb
            name="finance"
            defaultTitle="breadcrumb.finance"
          />
        ),
      },
      {
        path: "/employee/detail/:id/finance/cash-receipt",
        element: (
          <ProtectedRoute name="cash_receipt">
            <EmployeeCashReceipt />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb
            name="cash_receipt"
            defaultTitle="cashReceipt.title"
          />
        ),
        children: [
          {
            path: "/employee/detail/:id/finance/cash-receipt/add",
            element: <AddEmployeeCashReceipt />,
            breadcrumb: null,
          },
          {
            path: "/employee/detail/:id/finance/cash-receipt/detail/:cashReceiptId",
            element: <DetailEmployeeCashReceipt />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/employee/detail/:id/finance/reimbursement",
        element: (
          <ProtectedRoute name="reimbursement">
            <EmployeeReimburse />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb
            name="reimbursement"
            defaultTitle="reimbursement.title"
          />
        ),
        children: [
          {
            path: "/employee/detail/:id/finance/reimbursement/add",
            element: <AddReimburseEmployee />,
            breadcrumb: null,
          },
          {
            path: "/employee/detail/:id/finance/reimbursement/detail/:reimbursementId",
            element: <DetailReimburse />,
            breadcrumb: null,
          },
          {
            path: "/employee/detail/:id/finance/reimbursement/edit/:reimbursementId",
            element: <EditReimburse />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/employee/detail/:id/finance/petty-cash",
        element: (
          <ProtectedRoute name="petty_cash">
            <PettyCashEmployee />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb name={"pettyCash.petty_cash"} />
        ),
      },
      {
        path: "/employee/detail/:id/attendance-daily/tracking",
        element: (
          <ProtectedRoute name="location_tracking">
            <EmployeeTracking />
          </ProtectedRoute>
        ),
        breadcrumb: () => (
          <TranslationBreadcrumb
            name="location_tracking"
            defaultTitle="tracking.title"
          />
        ),
      },
      {
        path: "/employee/detail/:id/task",
        element: <EmployeeTask />,
        breadcrumb: () => (
          <TranslationBreadcrumb name="task" defaultTitle="task.title" />
        ),
        children: [
          {
            path: "/employee/detail/:id/task/add",
            element: <AddTask />,
            breadcrumb: () => <TranslationBreadcrumb name="task.add_task" />,
          },
        ],
      },
      {
        path: "/employee/detail/:id/task/detail/:idTask",
        element: <EmployeeDetailTask />,
        breadcrumb: () => <TranslationBreadcrumb name="task.detail" />,
        children: [
          {
            path: "/employee/detail/:id/task/detail/:idTask/duplicate",
            element: <DuplicateTask />,
            breadcrumb: () => (
              <TranslationBreadcrumb name="task.duplicate_task" />
            ),
          },
          {
            path: "/employee/detail/:id/task/detail/:idTask/edit",
            element: <EditTask />,
            breadcrumb: () => <TranslationBreadcrumb name="task.edit_task" />,
          },
        ],
      },
    ],
  },
];

export default employeeRoutes;
